import extractDataFromColDefs from 'lib/helpers/exportPdf/lib/extractDataFromColDefs';
import { ia } from 'lib/helpers/utility';

import { generateColumnDefs } from 'components/practice/BeyondBilling/Reports/components/ReportView/lib/generateColumnDefs';

// Function to flatten nested children data for CSV/Excel export
// mode: 'summary' = parent rows only, 'detailed' = child rows only
export const flattenNestedData = (rows, columns, { mode = 'summary' } = {}) => {
  const isDetailed = mode === 'detailed';

  if (!isDetailed) {
    // Summary mode: just format and return parent-level rows (no children)
    return extractDataFromColDefs(rows, columns);
  }

  // Detailed mode: return only the leaf (child) rows
  let result = [];

  rows.forEach((row) => {
    const children = row.children;

    if (ia(children)) {
      const childCols = ia(columns) ? columns : generateColumnDefs(children);
      const formattedChildren = extractDataFromColDefs(children, childCols);
      result = result.concat(formattedChildren);
    }
  });

  return result;
};
